module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/de056df8d895f6eb4e1992bc43c0c5e3.png";